import { useState, useEffect } from 'react';
import { useLang } from '../context/LanguageContext';
import { fetchPhotos } from '../services/api';

export default function Gallery() {
  const { lang } = useLang();
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchPhotos()
      .then(data => setPhotos(data.filter(p => p.is_active !== false)))
      .catch(() => setError(lang === 'fr' ? 'Impossible de charger la galerie.' : 'Unable to load gallery.'))
      .finally(() => setLoading(false));
  }, [lang]);

  const lbl = {
    title:   lang === 'fr' ? 'Galerie Photos'             : 'Photo Gallery',
    sub:     lang === 'fr' ? 'Nos moments partagés'       : 'Our shared moments',
    loading: lang === 'fr' ? 'Chargement...'              : 'Loading...',
    empty:   lang === 'fr' ? 'Aucune photo pour le moment.' : 'No photos yet.',
  };

  return (
    <>
      <section className="hero" style={{ background: 'linear-gradient(135deg,var(--primary) 0%,var(--secondary) 100%)', padding: '6rem 0 4rem' }}>
        <div className="container">
          <div style={{ textAlign: 'center', color: 'white' }} className="fade-in-up">
            <span style={{ display: 'inline-block', padding: '8px 20px', background: 'rgba(255,255,255,0.2)', color: 'white', fontWeight: 700, fontSize: '0.875rem', borderRadius: 20, marginBottom: '1.5rem', textTransform: 'uppercase', letterSpacing: 1 }}>WACEAS</span>
            <h1 style={{ fontSize: '3rem', color: 'white', marginBottom: '1rem' }}>{lbl.title}</h1>
            <p style={{ fontSize: '1.125rem', opacity: 0.9 }}>{lbl.sub}</p>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          {loading && (
            <div style={{ textAlign: 'center', padding: '5rem', color: 'rgba(26,26,26,0.5)' }}>
              <i className="fas fa-spinner fa-spin" style={{ fontSize: '2.5rem', display: 'block', marginBottom: '1rem' }}></i>
              {lbl.loading}
            </div>
          )}
          {error && (
            <div style={{ textAlign: 'center', padding: '5rem', color: 'var(--secondary)' }}>
              <i className="fas fa-exclamation-circle" style={{ fontSize: '2.5rem', display: 'block', marginBottom: '1rem' }}></i>
              {error}
            </div>
          )}
          {!loading && !error && photos.length === 0 && (
            <div style={{ textAlign: 'center', padding: '5rem', color: 'rgba(26,26,26,0.5)' }}>
              <i className="fas fa-images" style={{ fontSize: '3rem', display: 'block', marginBottom: '1rem' }}></i>
              {lbl.empty}
            </div>
          )}
          {!loading && photos.length > 0 && (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(280px,1fr))', gap: '1.5rem' }}>
              {photos.map(photo => (
                <div key={photo.id} className="card fade-in-up" style={{ padding: 0, overflow: 'hidden', cursor: 'pointer' }} onClick={() => setSelected(photo)}>
                  <div style={{ aspectRatio: '4/3', overflow: 'hidden' }}>
                    <img
                      src={photo.url} alt={photo.title}
                      style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.3s' }}
                      onMouseOver={e => (e.currentTarget.style.transform = 'scale(1.05)')}
                      onMouseOut={e => (e.currentTarget.style.transform = 'scale(1)')}
                    />
                  </div>
                  <div style={{ padding: '1rem' }}>
                    <h4 style={{ margin: '0 0 0.3rem', fontSize: '1rem' }}>{photo.title}</h4>
                    {photo.category && <span style={{ fontSize: '0.8rem', color: 'var(--primary)', fontWeight: 600 }}>{photo.category}</span>}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {selected && (
        <div onClick={() => setSelected(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.92)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
          <button onClick={() => setSelected(null)} style={{ position: 'absolute', top: '1.5rem', right: '1.5rem', background: 'rgba(255,255,255,0.15)', border: 'none', color: 'white', fontSize: '1.5rem', width: 44, height: 44, borderRadius: '50%', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <i className="fas fa-times"></i>
          </button>
          <div onClick={e => e.stopPropagation()} style={{ maxWidth: '88vw', maxHeight: '88vh', textAlign: 'center' }}>
            <img src={selected.url} alt={selected.title} style={{ maxWidth: '100%', maxHeight: '75vh', objectFit: 'contain', borderRadius: 8 }} />
            <p style={{ color: 'white', marginTop: '1rem', fontSize: '1.125rem', fontWeight: 600 }}>{selected.title}</p>
            {selected.description && <p style={{ color: 'rgba(255,255,255,0.65)', marginTop: '0.25rem' }}>{selected.description}</p>}
          </div>
        </div>
      )}
    </>
  );
}
